import { FC } from 'react';

import { Alert, AlertDescription, AlertIcon, StyleProps } from '@bonusly/design-system';

interface FormErrorProps extends StyleProps {
	error: string;
}

export const FormError: FC<FormErrorProps> = ({ error, ...rest }) => (
	<Alert status="error" backgroundColor="red.50" borderRadius="md" py={2} px={3} {...rest}>
		<AlertIcon color="red.700" />
		<AlertDescription color="red.700" fontSize="sm">
			{error}
		</AlertDescription>
	</Alert>
);
